import estilos from './Paginacion.module.css'

type PropsPaginacion = {
  /** Página actual, empezando en cero. */
  pagina: number
  porPagina: number
  /** Total de registros que cumplen el filtro, no los que están en pantalla. */
  total: number
  onCambiar: (pagina: number) => void
}

/**
 * Paginación de una lista larga.
 *
 * Los maestros de World Office pasan de dos mil registros cada uno. Traerlos
 * completos al navegador no es una lista, es un volcado: pesa, tarda y no se
 * puede recorrer. El corte va en la consulta, no aquí.
 *
 * Se muestra el rango y el total —«51 a 100 de 2.566»— y no solo el número de
 * página, porque lo que la persona quiere saber es cuánto falta.
 */
export function Paginacion({ pagina, porPagina, total, onCambiar }: PropsPaginacion) {
  if (total === 0) return null

  const paginas = Math.max(1, Math.ceil(total / porPagina))
  const desde = pagina * porPagina + 1
  const hasta = Math.min((pagina + 1) * porPagina, total)

  const hayAnterior = pagina > 0
  const haySiguiente = pagina + 1 < paginas

  return (
    <nav className={estilos.paginacion} aria-label="Paginación">
      <p className={estilos.cuenta}>
        <b>{desde.toLocaleString('es-CO')}</b> a <b>{hasta.toLocaleString('es-CO')}</b> de{' '}
        <b>{total.toLocaleString('es-CO')}</b>
      </p>

      <div className={estilos.controles}>
        <button
          type="button"
          className={estilos.boton}
          onClick={() => onCambiar(0)}
          disabled={!hayAnterior}
          aria-label="Primera página"
        >
          ««
        </button>

        <button
          type="button"
          className={estilos.boton}
          onClick={() => onCambiar(pagina - 1)}
          disabled={!hayAnterior}
        >
          « Anterior
        </button>

        <span className={estilos.pagina}>
          {pagina + 1} / {paginas}
        </span>

        <button
          type="button"
          className={estilos.boton}
          onClick={() => onCambiar(pagina + 1)}
          disabled={!haySiguiente}
        >
          Siguiente »
        </button>

        <button
          type="button"
          className={estilos.boton}
          onClick={() => onCambiar(paginas - 1)}
          disabled={!haySiguiente}
          aria-label="Última página"
        >
          »»
        </button>
      </div>
    </nav>
  )
}
